import { IThangDiem } from "../models/response/so-diem/IThangDiem"
import { apiClient } from "./apiClient"


export const THANG_DIEM_RESOURCE = "thang-diem"
export const THANG_DIEM_DELETE_RESOURCE = "thang-diem/{id}"
export const THANG_DIEM_BY_TRUONG_RESOURCE = "thang-diem/truong/{dm_truong_id}"
export const thangDiemApi = {
    SelectByTruong: (dm_truong_id: number) => apiClient.get(`${THANG_DIEM_RESOURCE}/truong/${dm_truong_id}`),
    Delete: (id: number) => apiClient.delete(`${THANG_DIEM_RESOURCE}/${id}`),
    Insert: (payload: IThangDiem) => apiClient.post(`${THANG_DIEM_RESOURCE}`, payload),
    Update: (payload: IThangDiem) => apiClient.put(`${THANG_DIEM_RESOURCE}`, payload),
}